import { SendCondition, SendConditions } from 'pages/Automations/types/AutomationSendConditions';

export const getVisibleSendConditions = (sendConditions: SendConditions): SendCondition[] => {
  return (Object.values(sendConditions) as SendCondition[]).filter((sendCondition) => !!sendCondition);
};
